"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = () => {};

var Video = (_ref) => {
  var {
    url,
    thumbnail,
    autoplay = false,
    preview = true,
    onError = noop
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactPlayer.default, {
    controls: !preview,
    playing: !preview && autoplay,
    muted: autoplay,
    loop: !preview,
    onError: onError,
    width: "100%",
    height: "100%",
    url: url,
    playsinline: true,
    config: {
      vimeo: {
        playerOptions: {
          autoplay
        }
      },
      file: {
        attributes: {
          poster: thumbnail
        }
      }
    }
  });
};

Video.propTypes = {
  /**
   * The url of the video to be played
   */
  url: _propTypes.default.string.isRequired,

  /**
   * To autoplay the video or not, only works in non-preview mode
   */
  autoplay: _propTypes.default.bool,

  /**
   * Set the player in preview mode where no controls are displayed and video cannot be autoplayed
   */
  preview: _propTypes.default.bool,
  onError: _propTypes.default.func,
  thumbnail: _propTypes.default.string
};
var _default = Video;
exports.default = _default;